import * as constants from '../constants';

export function setLanguage(payload) {
  return {
    type: constants.SET_LANGUAGE,
    payload,
  };
}
